@if (loading$ | async) {
  <ng-container *ngTemplateOutlet="loading"></ng-container>
} @else {
  <div class="payment-type--title" data-test="checkout-payment-type--title-container">
    <h2
      class="h-500 m-0"
      data-test="checkout-payment-type--title-value"
    >{{ 'checkoutProgress.deliveryMode' | cxTranslate }}</h2>
  </div>
  <mat-card class="mt-3" data-test="checkout-payment-type--card-body">
    @if ((paymentTypes$ | async)?.length && typeSelected$ | async) {
      <div>
        <h3 class="mb-3" data-test="checkout-payment-type--method-title">{{ 'paymentTypes.title' | cxTranslate }}</h3>
        @for (type of paymentTypes$ | async; track type.code) {
          <div class="payment-radio" [attr.data-test]="'checkout-payment-type--'+ type.code + 'container'">
            <input [attr.data-test]="'checkout-payment-type--'+ type.code + 'radio'"
              id="paymentType-{{ type.code }}"
              type="radio"
              aria-checked="true"
              (change)="changeType(type.code)"
              [value]="type.code"
              [checked]="type.code === typeSelected"
            />
            <label for="paymentType-{{ type.code }}"
                   [attr.data-test]="'checkout-payment-type--'+ type.code + 'label'">
              {{ 'paymentTypes.paymentType_' + type?.code | cxTranslate }}
            </label>
          </div>
        }
      </div>
    } @else {
      <ng-container *ngTemplateOutlet="loading"></ng-container>
    }
  </mat-card>
}

<ng-template #loading>
  <mat-card class="mt-3" data-test="checkout-payment-type--loader-card">
    <div class="cx-spinner" data-test="checkout-payment-type--loader-container">
      <cx-spinner data-test="checkout-payment-type--spinner"></cx-spinner>
    </div>
  </mat-card>
</ng-template>
